<template>
  <div v-if="faIconClass !== '' || text !==''" class="a-toggle">
    <span @click="$emit('toggleEditable')">
      <i v-if="faIconClass !== ''" :class="faIconClass" aria-hidden="true"></i>{{ text }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    faIconClass: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// ToggleText.vue?77ff22c9